import { render, staticRenderFns } from "./autocomplete-shop-product.vue?vue&type=template&id=13e5a67d&"
import script from "./autocomplete-shop-product.vue?vue&type=script&lang=js&"
export * from "./autocomplete-shop-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports